'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
    async getFileRequests() {
        const data = {
            method: 'get',
            url: 'file-requests',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createFileRequest(json) {
        const data = {
            method: 'post',
            url: 'file-request',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('File request sent successfully')
            return true;
        }
    },
    async getEmployeeFileRequests(employeeId) {
        const data = {
            method: 'get',
            url: 'file-request/' + employeeId + '/employee',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
}
